import styled from "../../styled";
import * as React from "react";
export const DetailRow = styled("div") `
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: ${({ theme, small }) => small ? theme.font.size - 2 : theme.font.size}px;
	line-height: 1.3;
	margin-bottom: ${({ spacing }) => spacing || 10}px;
	padding-bottom: ${({ spacing }) => spacing || 10}px;
	border-bottom: 1px dashed ${({ theme }) => theme.box.border};
	&:last-child {
		border-bottom: none;
		margin-bottom: 0;
		padding-bottom: 0;
	}
	> * {
		&.small,
		.small {
			font-size: ${({ theme }) => theme.font.size > 14 ? theme.font.size - 2 : theme.font.size}px;
		}
		&.smaller,
		.smaller {
			font-size: ${({ theme }) => theme.font.size > 14
    ? theme.font.size - 2
    : theme.font.size - 1}px;
		}
		&:first-child {
			margin-right: 20px;
			min-width: ${({ leftColumnWidth }) => leftColumnWidth || 80}px;
			text-align: left;
		}
		&:last-child {
			flex-grow: 1;
			min-width: 65px;
			text-align: right;
			word-break: break-word;
		}
	}
`;
export const DetailRowList = (props) => {
    return (React.createElement("div", null, props.items.map((item, i) => {
        if (!item)
            return null;
        if ((!props.showNull || !item.sn) && !item.v) {
            return null;
        }
        if (item.h)
            return null;
        const valueDivProps = item.noTranslate ? { className: "notranslate" } : {};
        if (item.highlighted)
            return (React.createElement(DetailRow, { key: i, ...props },
                React.createElement("div", { className: "ql-size-big font-bold lh14" }, item.l),
                React.createElement("div", { className: item.noTranslate
                        ? "ql-size-big font-bold lh14 notranslate"
                        : "ql-size-big font-bold lh14" }, item.v)));
        return (React.createElement(DetailRow, { key: i, ...props },
            React.createElement("div", null, item.l),
            React.createElement("div", { ...valueDivProps }, item.v)));
    })));
};
//# sourceMappingURL=DetailRow.js.map